import React from 'react';
import Sidebar from '@/components/Sidebar';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import SupportForm from '@/components/settings/SupportForm';
import { Link } from 'react-router-dom';
import { ArrowLeft, HelpCircle, Wand2, MessageSquare, FileText } from 'lucide-react';

const Support = () => {
  return (
    <div className="flex h-screen bg-background">
      <Sidebar />
      
      <main className="flex-1 overflow-y-auto">
        <div className="p-8">
          <div className="mb-8 animate-fade-in">
            <h1 className="text-3xl font-bold text-roundone-dark-purple mb-2">Help & Support</h1>
            <p className="text-muted-foreground">Get help with RoundOne and submit support requests</p>
          </div>
          
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Support Form Section */}
            <div className="lg:col-span-2">
              <Card className="glass-card">
                <CardHeader className="pb-2">
                  <CardTitle>Contact Support</CardTitle>
                  <CardDescription>Submit a request and our team will get back to you</CardDescription>
                </CardHeader>
                <CardContent className="pt-4">
                  <SupportForm />
                </CardContent>
              </Card>
            </div>
            
            {/* Resources Section */}
            <div className="space-y-6">
              <Card className="glass-card">
                <CardHeader className="pb-2">
                  <CardTitle>Support Resources</CardTitle>
                  <CardDescription>Helpful resources for using RoundOne</CardDescription>
                </CardHeader>
                <CardContent className="pt-4">
                  <ul className="space-y-4">
                    <li>
                      <Link 
                        to="/faq" 
                        className="flex items-center p-3 hover:bg-gray-50 rounded-md transition-colors"
                      >
                        <HelpCircle className="mr-3 h-5 w-5 text-roundone-purple" />
                        <span>Frequently Asked Questions</span>
                      </Link>
                    </li>
                    <li>
                      <Link 
                        to="/tutorials" 
                        className="flex items-center p-3 hover:bg-gray-50 rounded-md transition-colors"
                      >
                        <Wand2 className="mr-3 h-5 w-5 text-roundone-purple" />
                        <span>Tutorials & Guides</span>
                      </Link>
                    </li>
                    <li>
                      <a 
                        href="https://roundone.ai/blog" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="flex items-center p-3 hover:bg-gray-50 rounded-md transition-colors"
                      >
                        <FileText className="mr-3 h-5 w-5 text-roundone-purple" />
                        <span>Blog & Documentation</span>
                      </a>
                    </li>
                    <li>
                      <a 
                        href="mailto:support@roundone.ai" 
                        className="flex items-center p-3 hover:bg-gray-50 rounded-md transition-colors"
                      >
                        <MessageSquare className="mr-3 h-5 w-5 text-roundone-purple" />
                        <span>Email Support</span>
                      </a>
                    </li>
                  </ul>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Support; 